import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { listAllContentIngestion, validateContentIngestion } from "./actions";

const contentIngestionAdapter = createEntityAdapter();

const initialState = contentIngestionAdapter.getInitialState({
  isContentIngestionValidated: false,
  validatedFiles: [],
  isValidatingContentIngestion: false,
  currentPage: 1,
  totalPages: 1,
  isLoadingMore: false,
});

const contentIngestionSlice = createSlice({
  name: "contentIngestion",
  initialState,
  reducers: {
    resetContentIngestionState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateContentIngestion.pending, (state) => {
        state.isValidatingContentIngestion = true;
      })
      .addCase(validateContentIngestion.rejected, (state) => {
        state.isValidatingContentIngestion = false;
        state.validatedFiles = [];
        state.isContentIngestionValidated = false;
      })
      .addCase(validateContentIngestion.fulfilled, (state, action) => {
        state.isValidatingContentIngestion = false;
        if (action.payload.statusCode === 200) {
          state.validatedFiles = action.payload.data.data.files;
          state.isContentIngestionValidated = true;
        }
      })
      .addCase(listAllContentIngestion.pending, (state, action) => {
        const page = action.meta.arg?.payload?.page || 1;
        if (page > 1) {
          state.isLoadingMore = true;
        }
      })
      .addCase(listAllContentIngestion.rejected, (state) => {
        state.isLoadingMore = false;
      })
      .addCase(listAllContentIngestion.fulfilled, (state, action) => {
        state.isLoadingMore = false;
        if (action.payload.statusCode === 200) {
          const { items = [], currentPage = 1, totalPages = 1 } = action.payload.data;
          if (currentPage === 1) {
            contentIngestionAdapter.setAll(state, items);
          } else {
            contentIngestionAdapter.upsertMany(state, items);
          }
          state.currentPage = currentPage;
          state.totalPages = totalPages;
        }
      });
  },
});

export const contentIngestionEntitySelectors = contentIngestionAdapter.getSelectors((state) => state.contentIngestion);

export const { resetContentIngestionState } = contentIngestionSlice.actions;
export default contentIngestionSlice.reducer;
